import Vue from "vue";
import App from "./app";
import AppRouter from "./router";
import Vuex from "vuex";
import Axios from "axios";
import store from "./store";
import authService from "@/services/auth";
import VueI18n from "vue-i18n";
import messages from "./locale";
import jQuery from "jquery";
import SideBar from "./components/SidebarPlugin";
// Tabs plugin. Used on Panels page.
import VueMaterial from "vue-material";
import DashboardPlugin from "./material-dashboard";
// asset imports
import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import sweetAlert from "./plugins/sweetAlert";

// plugins
import developmentPlugin from "@/plugins/developmentUtils";
import permissionsPlugin from "@/plugins/accountPermissions";

// Editor Photos
import "normalize.css";
import "cropperjs/dist/cropper.css";

import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings } from "luxon";
import HandledError from "@/utils/handledError";

Settings.defaultLocale = "es";
Settings.defaultZoneName = "America/Mexico_City";

// Sorteable for Image Editor

const isQA = window.location.href.startsWith("https://qa.");

Vue.config.debug = process.env.NODE_ENV !== "production";
Vue.config.appName =
  (Vue.config.debug ? "[DEV] " : isQA ? "[QA] " : "") + "Freedom 7";

// Setting Axios
const LOGOUT_URL = "/auth/logoutall/";
Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.xsrfCookieName = "csrftoken";
Axios.defaults.xsrfHeaderName = "X-CSRFToken";
Axios.defaults.headers.common.Accept = "application/json";
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const { authenticated } = store.state.auth;
      const { currentRoute } = Vue.router;
      const {
        config: { url },
      } = error;
      const isLogout = url === LOGOUT_URL; // To avoid loop
      const fullPath =
        currentRoute.name === "Login" || currentRoute.fullPath === "/"
          ? undefined
          : currentRoute.fullPath;
      return authenticated && !isLogout
        ? authService.logout({ nextURL: fullPath })
        : Vue.router.push({
            name: "Login",
            query: {
              nextURL: fullPath,
            },
          });
    }
    throw new HandledError(error);
  }
);

Axios.interceptors.request.use((config) => {
  store.dispatch("incLoadingContent");
  return config;
});

Axios.interceptors.response.use(
  (response) => {
    store.dispatch("incLoadingContent", -1);
    return response;
  },
  (error) => {
    store.dispatch("incLoadingContent", -1);
    return Promise.reject(error);
  }
);

Vue.$http = Axios;
Object.defineProperty(Vue.prototype, "$http", {
  get() {
    return Axios;
  },
});

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

import Tabs from "vue-tabs-component";

Vue.use(Tabs);

// Settings JQuery
window.$ = window.jQuery = jQuery;

require("bootstrap/less/bootstrap.less");
require("font-awesome/less/font-awesome.less");
require("./assets/stylus/app.styl");

// SECTION FILTERS
import {
  booleanToState,
  shortDate,
  shortShortDate,
  fromNowDate,
  money,
  moneyLong,
  debugValue,
  longDate,
  fileSize,
} from "./filters";

Vue.filter("booleanToState", booleanToState);
Vue.filter("shortDate", shortDate);
Vue.filter("shortShortDate", shortShortDate);
Vue.filter("fromNowDate", fromNowDate);
Vue.filter("money", money);
Vue.filter("moneyLong", moneyLong);
Vue.filter("longDate", longDate);
Vue.filter("fileSize", fileSize);
Vue.filter("$debug", debugValue);
/*
more filters
*/

// gallerys and Editors
import VueLazyLoad from "vue-lazyload";

Vue.use(VueLazyLoad);

store.dispatch("auth/check");
store.dispatch("auth/checkViewAs");
Vue.use(Vuex);
Vue.use(SideBar);
Vue.use(VueMaterial);
Vue.use(DashboardPlugin);
Vue.use(Datetime);
Vue.use(AppRouter);
// plugins
Vue.use(permissionsPlugin);
Vue.use(developmentPlugin);
Vue.use(sweetAlert);

new Vue({
  el: "#app",
  router: Vue.router,
  store,
  i18n,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js